export default __webpack_public_path__ + "static/media/serv-04.708ba947.jpg";